import React from "react";
import { useSearchParams } from "react-router-dom";
import { PageContainer, PageHeader } from "../components/kit";
import SupportChat from "../components/SupportChat";

// Full-page view of the same conversation the nav peek shows — the peek is cramped on a phone, and
// a longer history is easier to read here.
export default function Support() {
  // ?draft=<id> — "Report a problem" on a failed application lands here with that job attached, so
  // the first message already says which one it is.
  const [params] = useSearchParams();
  const draftId = params.get("draft") || null;
  return (
    <PageContainer width="prose">
      <PageHeader
        eyebrow="Support"
        title="Messages."
        subtitle="Talk to us about anything that isn't working — an application that keeps failing, your résumé, or your account."
      />
      <div className="rounded-2xl border border-border bg-white overflow-hidden h-[min(70vh,640px)] flex flex-col">
        <SupportChat draftId={draftId} />
      </div>
    </PageContainer>
  );
}
